import CardFixed from "components/Card/CardFixed";
import {
  checkDateOrder,
  dataEmpty,
  getDefaultValue,
  SubLine,
} from "components/CommonLib/CommonLib";
import CustomPagination from "components/CustomPagination/CustomPagination";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import { CustomRow, CustomTableContents } from "components/CustomTable/tableStyle";
import ComboBox from "components/LabelInput/ComboBox";
import DatePicker from "components/LabelInput/DatePicker";
import Label from "components/LabelInput/Label";
import SearchComboBox from "components/LabelInput/SearchComboBox";
import Loading from "components/Loading/Loading/Loading";
import NormalBtn from "components/NewButton/NormalBtn";
import { useGetAuthData } from "hooks/apis/access/useAuth";
import {
  useDailyReportList,
  useDailyReportSearchParam,
  useMonthlySalesByBranch,
} from "hooks/apis/salary/useDailyReport";
import { globalModalOn } from "modules/actions/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DailySalesModal from "../Modal/DailySalesModal";
import { useDailyReportStore } from "../modules/store/dailyReportState";

import { exportToExcel } from "./MakeExcel";
import { SearchConditionBox, SearchContainer, SearchRowBox } from "./style";

const DailyReportListView = () => {
  const storesDispatch = useDispatch();
  const navigate = useNavigate();
  // 페이지 구성 변수
  const labelWidth = "4.5rem";
  const textBoxWidth = "15rem";
  const textBoxWidthShort = "10rem";

  // 전역 상태 관리
  const {
    dailyReportSearchParams: searchParams,
    setSearchParams,
    dailyReportHqIdx: hqIdx,
    setHqIdx,
    setPage,
    dailyReportPage: page,
  } = useDailyReportStore();
  // 페이지 상태 관리
  const [hqBranchListData, setHqBranchListData] = useState({});
  const [branchList, setBranchList] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [isFirstEnterPage, setIsFirstEnterPage] = useState(true);
  const [isExcel, setIsExcel] = useState(false);
  const [isMakeExcel, setIsMakeExcel] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [excelOptions, setExcelOptions] = useState({
    mbshp_total_sales: false,
    other_total_sales: false,
    mbshp_and_other_total_sales: false,
    pt_total_sales: false,
    sales_total: false,
  });
  // API 상태 관리
  const [isGetDailyReportList, setIsGetDailyReportList] = useState(false);
  const [isGetMonthlySalesList, setIsGetMonthlySalesList] = useState(false);
  const queryData = { page: page, searchParams: searchParams };

  // API Query
  // [GET] 권한 정보 가져오기
  const { data: authData } = useGetAuthData();

  // [GET] 운영 일지 검색 조건 받아오기 및 권한 데이터 세팅
  const { data: firstSearchParamData } = useDailyReportSearchParam(isFirstEnterPage);

  // [GET] 운영 일지 내역 리스트 검색
  const { isFetching, data: dailyReportListData } = useDailyReportList(
    queryData,
    isGetDailyReportList,
    setIsGetDailyReportList,
  );

  // [GET] 여러 지점의 운영일지 월간 매출 조회
  const monthlySalesList = useMonthlySalesByBranch(excelData, isGetMonthlySalesList);
  // 엑셀 데이터 로딩
  const isMonthlySalesFetching = monthlySalesList.some((query) => query.isFetching);

  // 결과 검색
  const onClickSearch = (page, isExcel) => {
    setIsExcel(isExcel);
    setPage(page);
    setIsGetDailyReportList(true);
    if (isExcel) {
      setIsGetMonthlySalesList(true);
    }
  };
  // 매출 자료 모달 열기
  const openModal = (
    hqBranchListData,
    setHqIdx,
    onClickSearch,
    setSearchParams,
    excelOptions,
    setExcelOptions,
  ) => {
    storesDispatch(
      globalModalOn({
        show: true,
        title: "매출 자료",
        Content: (
          <DailySalesModal
            hqBranchListData={hqBranchListData}
            setHqIdx={setHqIdx}
            onClickSearch={onClickSearch}
            setSearchParams={setSearchParams}
            excelOptions={excelOptions}
            setExcelOptions={setExcelOptions}
          />
        ),
      }),
    );
  };

  // API 받아온 데이터 세팅
  useEffect(() => {
    if (firstSearchParamData) {
      const { combo_selector } = firstSearchParamData.data.data;
      // 첫 검색 조건
      if (searchParams.hq_info.hq_id === "") {
        setSearchParams("hq_info", combo_selector.target_list[0].hq_info);
        setSearchParams("branch_info", combo_selector.target_list[0].branch_list[0]);
        setSearchParams("combo_selector", combo_selector);
      }
      // 본부 및 지점 정보
      setHqBranchListData(combo_selector);
      setBranchList(combo_selector.branch_list[hqIdx]);
    }

    // 검색 결과 데이터 세팅
    if (dailyReportListData) {
      if (isExcel) {
        setExcelData(dailyReportListData.data.data);
        setIsMakeExcel(true);
      } else {
        setSearchResult(dailyReportListData.data.data);
        setTotalPage(dailyReportListData.data.total_page);
      }
    }
  }, [firstSearchParamData, dailyReportListData, isExcel]);

  // 본부 선택에 따른 지점 리스트 다시 세팅
  useEffect(() => {
    if (hqBranchListData.branch_list) setBranchList(hqBranchListData.branch_list[hqIdx]);
    //  첫 페이지 진입이 아니고 본부 변경 시 지점 초기화 세팅
    if (!isFirstEnterPage) {
      const branchParams = hqBranchListData.target_list[hqIdx].branch_list[0];
      setSearchParams("branch_info", branchParams);
    }
  }, [hqIdx]);

  // 페이지 진입 시 결과 리스트
  useEffect(() => {
    if (isFirstEnterPage && searchParams.hq_info.hq_id !== "") {
      setIsGetDailyReportList(true);
      setIsFirstEnterPage(false);
    }
  }, [searchParams.hq_info.hq_id]);

  // 엑셀 만들기
  useEffect(() => {
    // 모든 쿼리가 성공적으로 완료되었는지 확인
    const isAllSuccess = monthlySalesList.every((query) => query.isSuccess && query.data);
    // 데이터가 모두 준비되었을 때만 엑셀 출력 및 useQueries 정지
    if (isMakeExcel && isAllSuccess && !isMonthlySalesFetching) {
      // useQueries 정지
      setIsGetMonthlySalesList(false);
      setIsMakeExcel(false);

      const processedData = monthlySalesList.map((query) => {
        const { mbshp_total_sales, other_total_sales, pt_total_sales, sales_total } =
          query.data.data.data.find((item) => item.sales_type === "총계");

        return {
          base_date: query.data.base_date,
          branch_name: query.data.branch_name,
          sales_total,
          mbshp_total_sales,
          other_total_sales,
          mbshp_and_other_total_sales: mbshp_total_sales + other_total_sales,
          pt_total_sales,
        };
      });

      if (processedData.length > 0) {
        exportToExcel(
          processedData,
          `${searchParams.hq_info.hq_name}_${processedData[0].base_date}_매출자료`,
          excelOptions,
        );
      }
    }
  }, [monthlySalesList]);

  // 권한 정보 세팅
  useEffect(() => {
    if (authData) {
      setIsAdmin(authData.data.data.is_admin);
    }
  }, [authData]);

  const searchResultList = new resultTable(navigate);

  return (
    <div>
      {(isFetching || isMonthlySalesFetching) && <Loading />}

      <CardFixed
        midDom={
          <div>
            <SearchContainer>
              <Label labelText="검색 조건" fontWeight="bold" justifyContent="flex-start" />
              <SearchRowBox
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    onClickSearch(1, false);
                  }
                }}
              >
                <SearchConditionBox width="24%">
                  <ComboBox
                    labelText="본부"
                    labelWidth={labelWidth}
                    comboItemWidth={textBoxWidth}
                    data={hqBranchListData && hqBranchListData.hq_list}
                    defaultValue={getDefaultValue("combo", searchParams.hq_info.hq_name)}
                    onChangeCallback={(e, idx) => {
                      setHqIdx(idx);
                      const hqParams = hqBranchListData.target_list[idx].hq_info;
                      setSearchParams("hq_info", hqParams);
                    }}
                  />
                </SearchConditionBox>
                <SearchConditionBox width="24%">
                  <SearchComboBox
                    labelText="지점"
                    labelWidth={labelWidth}
                    comboItemWidth={textBoxWidth}
                    data={branchList}
                    defaultValue={getDefaultValue("combo", searchParams.branch_info.branch_name)}
                    onChangeCallback={(e, v, idx) => {
                      const branchParams = hqBranchListData.target_list[hqIdx].branch_list[idx];
                      setSearchParams("branch_info", branchParams);
                    }}
                  />
                </SearchConditionBox>
                <SearchConditionBox width="26.5%">
                  <DatePicker
                    labelText="날짜"
                    labelWidth={labelWidth}
                    textBoxWidth={textBoxWidthShort}
                    labelMarginRight="0rem"
                    textMarginRight="0rem"
                    defaultValue={getDefaultValue("field", searchParams.base_from_date)}
                    onChangeCallback={(e) => {
                      setSearchParams("base_from_date", e);
                    }}
                    onBlur={(e) => {
                      if (!checkDateOrder(e, searchParams.base_to_date)) {
                        setSearchParams("base_from_date", "");
                      }
                    }}
                  />
                  <DatePicker
                    marginLeft="0.25rem"
                    labelWidth="0.5rem"
                    textBoxWidth={textBoxWidthShort}
                    labelMarginRight="0.25rem"
                    labelText="~"
                    defaultValue={getDefaultValue("field", searchParams.base_to_date)}
                    onChangeCallback={(e) => {
                      setSearchParams("base_to_date", e);
                    }}
                    onBlur={(e) => {
                      if (!checkDateOrder(searchParams.base_from_date, e)) {
                        setSearchParams("base_to_date", "");
                      }
                    }}
                  />
                </SearchConditionBox>
              </SearchRowBox>
            </SearchContainer>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "0.5rem",
              }}
            >
              <NormalBtn
                search
                name="검색"
                onClick={() => {
                  onClickSearch(1, false);
                }}
              />
            </div>
            <SubLine />
            {isAdmin && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <NormalBtn
                  name="매출 자료 다운로드"
                  theme="green"
                  onClick={() =>
                    openModal(
                      hqBranchListData,
                      setHqIdx,
                      onClickSearch,
                      setSearchParams,
                      excelOptions,
                      setExcelOptions,
                    )
                  }
                />
              </div>
            )}
            <div style={{ marginTop: "0.5rem" }}>
              <CustomTable
                columns_head={searchResultList.columns_head}
                table_title={searchResultList.table_title}
                rest_call={searchResultList.get_data_from_rest}
                row_render={searchResultList.create_table}
                rest_data={searchResult}
              />
              <CustomPagination curPage={page} totalCnt={totalPage} doSearch={onClickSearch} />
            </div>
          </div>
        }
        isLoading={false}
        rootStyle={{
          width: "100%",
          height: "29rem",
          borderRadius: "10px",
          backgroundColor: "#fff",
        }}
      />
    </div>
  );
};
export default DailyReportListView;

//

class resultTable {
  table_title = "";
  onNavigate = null;

  constructor(navigate) {
    this.onNavigate = navigate;
  }

  onClickRow = (data) => {
    this.onNavigate("/daily_info/", {
      state: {
        reportInfoId: data.report_info_id,
      },
    });
  };

  create_table = (data, idx) => {
    return (
      <CustomRow
        style={{}}
        key={idx}
        onClick={(e) => {
          if (e.target.nodeName === "DIV" || e.target.nodeName === "TD") {
            this.onClickRow(data);
          }
        }}
        hover
      >
        <CustomTableContents>{data.base_date}</CustomTableContents>
        <CustomTableContents>{data.hq_info.hq_name}</CustomTableContents>
        <CustomTableContents>{data.branch_info.branch_name}</CustomTableContents>
        <CustomTableContents>
          {/* <IconButton
            type="update"
            width="2.3rem"
            tooltip="새로고침"
            onClick={() => {
              this.onClickUpdate();
            }}
          /> */}
        </CustomTableContents>
      </CustomRow>
    );
  };

  columns_head = [
    { title: "날짜", width: "30%" },
    { title: "본부", width: "30%" },
    { title: "지점", width: "30%" },
    { title: "", width: "10%" },
  ];

  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      stateData = [];
    }
    return stateData;
  };
}
